<template>

    <a class="btn_underline" @click="goRefsList">
        <span class="btn_underline_label">
            <slot />
        </span>
        <div class="btn_underline_tabbed_line"></div>
    </a>

</template>

<script>
export default {
    name: 'btnUnderline',
    props: ['link'],
    methods: {
        goRefsList(){
            if (this.link){
                this.$router.push(this.link)
            }else{
                this.$emit('actionClick')
            }
        }
    }
}


</script>

<style lang="scss" scoped>
.btn_underline{
    user-select: none;
    width: 180px;
    text-align: center;
    display: block;
    .btn_underline_label{
        color: $grey-dark;
        font-weight: 600;
        font-size: 1.4rem;
    }
    .btn_underline_tabbed_line{
        display: block;
        background: $info;
        height: 10px;
        width: 80px;
        margin: auto;
    }
}
</style>